<template>
  <div id="consumption_ozon_ship">
    <div v-if="receivedData">
      <CastomGraphic
          :received-data="receivedData"
          graph-type="line"
          index-axis="x"
          :id="'traffic-road-1-ozon'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>
  </div>
</template>
<script>
import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ConsumptionOzon',

  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'consumption_ozon',
      cloneElementId: 'consumption_ozon_ship'
    }
  },

  mounted () {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '18').then((response) => {
        this.receivedData = response.data[0]
      })
    }
  }
}
</script>